module.exports = __webpack_public_path__ + "static/media/S (86).128fcd7e.jpg";